"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoProviderTypeEnum = void 0;
var SsoProviderTypeEnum;
(function (SsoProviderTypeEnum) {
    SsoProviderTypeEnum["GOOGLE"] = "google";
    SsoProviderTypeEnum["AZURE_AD"] = "azure-ad";
})(SsoProviderTypeEnum || (exports.SsoProviderTypeEnum = SsoProviderTypeEnum = {}));
